export const FESTIVAL_THEMES = {
  shivratri: {
    name: "Maha Shivratri", icon: "🔱", border: "border-orange-400/50", bg: "from-orange-600/25 via-amber-500/15 to-blue-900/30",
    title: "महाशिवरात्रि स्पेशल", subtitle: "हर डिपॉज़िट पर त्योहार बोनस! हर हर महादेव", banner_url: "/festival_shivratri.jpg",
  },
  diwali: {
    name: "Diwali", icon: "🪔", border: "border-amber-400/60", bg: "from-amber-500/30 via-orange-500/15 to-rose-900/30",
    title: "दीपावली धमाका", subtitle: "रोशनी का त्योहार, बोनस की बौछार! शुभ दीपावली", banner_url: "/festival_diwali.jpg",
  },
  holi: {
    name: "Holi", icon: "🎨", border: "border-pink-400/50", bg: "from-pink-500/25 via-emerald-500/15 to-sky-600/25",
    title: "होली है!", subtitle: "रंगों के साथ जीत के रंग! हर डिपॉज़िट पर होली बोनस", banner_url: "/festival_holi.jpg",
  },
  navratri: {
    name: "Navratri", icon: "🌺", border: "border-rose-400/50", bg: "from-rose-700/30 via-orange-500/15 to-amber-500/20",
    title: "नवरात्रि स्पेशल", subtitle: "नौ दिन, नौ गुना खुशियाँ! जय माता दी", banner_url: "/festival_navratri.jpg",
  },
};
